<mat-dialog-content xmlns="http://www.w3.org/1999/html">
  <h2>Download data</h2>
  <mat-card-content>
    <form (submit)="downloadData()" [formGroup]="downloadDataForm" autocomplete="off">
      <div class="form-container">

        <mat-form-field appearance="outline" class="full-width-input" *ngIf="type !== 'intelligence' && type !== 'intelligencereporting'">
          <mat-label>Years</mat-label>
          <mat-select [formControl]="yearsControl" multiple>
            <mat-option #allSelected (click)="toggleAllYearsSelection()" [value]="0"><strong>All</strong></mat-option>
            <mat-option *ngFor="let year of years" [value]="year" (click)="toggleYearPerOne()">{{year}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width-input" *ngIf="type === 'intelligence'">
          <mat-label>Years</mat-label>
          <mat-select [formControl]="yearsControl">
            <mat-option *ngFor="let year of years" [value]="year">{{year}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width-input">
          <mat-label>Countries</mat-label>
          <mat-select [formControl]="type === 'intelligencereporting' ? countriesIntelligenceDataControl : countriesControl" multiple>
            <mat-option #allCountrySelected (click)="toggleAllCountriesSelected()" [value]="0"><strong>All</strong></mat-option>
            <mat-option *ngFor="let country of countries" (click)="type === 'intelligencereporting' ? toggleCountryIntelligencePerOne() :toggleCountryPerOne()" [value]="country.id">{{country.name}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width-input" *ngIf="type === 'intelligencereporting'">
          <mat-label>WEEE Systems</mat-label>
          <mat-select  [formControl]="weeeSystemsIntelligenceDataControl" multiple>
            <mat-option #allWeeeSystemsSelected (click)="toggleAllSystemsSelected()" [value]="0"><strong>All</strong></mat-option>
            <mat-option *ngFor="let weeeSystem of weeeSystems" [value]="weeeSystem.id">{{weeeSystem.description}}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="align-right buttons-container">
          <button mat-raised-button (click)="closeDialog()" type="button" >
            <span>Close</span>
          </button>
          <button [disabled]="downloadDataForm.invalid" mat-raised-button color="primary" type="submit">
            <span>Download</span>
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-dialog-content>
